export class PetBriefModel {
    brief_hist_sequence: number
    client_no: number
    pet_no: number
    brief_hist_category: string
    brief_hist_code: string
    brief_hist_date: any
    brief_hist_resp1: string
    brief_hist_resp2: string
    done_in_clinic: number
    confirmed: boolean
    brief_due_date: any

    constructor(
        brief_hist_sequence: number,
        client_no: number,
        pet_no: number,
        brief_hist_category: string,
        brief_hist_code: string,
        brief_hist_date: any,
        brief_hist_resp1: string,
        brief_hist_resp2: string,
        done_in_clinic: number,
        confirmed: boolean,
        brief_due_date: any
    ) {
        this.brief_hist_sequence = brief_hist_sequence
        this.client_no = client_no
        this.pet_no = pet_no
        this.brief_hist_category = brief_hist_category
        this.brief_hist_code = brief_hist_code
        this.brief_hist_date = brief_hist_date
        this.brief_hist_resp1 = brief_hist_resp1
        this.brief_hist_resp2 = brief_hist_resp2
        this.done_in_clinic = done_in_clinic
        this.confirmed = confirmed
        this.brief_due_date = brief_due_date
    }
}